export default __webpack_public_path__ + "static/media/timer.13d4dfc1.svg";